import APIService from '@/services/APIService.js'

export default {
  getAllValidacoes (includeExpiredRecords) {
    return APIService.apiCall().get(`/ValidacoesSdi/getAllValidacoes/${includeExpiredRecords}`)
  },
  salvar (postData) {
    return APIService.apiCall().post(`/ValidacoesSdi/salvar/${postData.id}`, JSON.stringify(postData))
  },
  deletar (id) {
    return APIService.apiCall().get(`/ValidacoesSdi/excluir/${id}`)
  },
  executar (id) {
    return APIService.apiCall().get(`/ValidacoesSdi/executar/${id}`)
  },
  uploadFile (postData) {
    return APIService.apiCall().post('ValidacoesSdi/upload', postData, {
      timeout: 60 * 60 * 1000,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  getTabelasModelo1 () {
    return APIService.apiCall().get('/ValidacoesSdi/getTabelasModelo1')
  },
  download (id, config = {}) {
    return APIService.apiCall().get(`/ValidacoesSdi/downloadArquivoResultado/${id}`, { responseType: 'blob', ...config })
  },
  downloadLogs (postData) {
    return APIService.apiCall().post('/ValidacoesSdi/downloadLogs/', JSON.stringify(postData), {
      responseType: 'blob',
      ...{ timeout: 60 * 60 * 1000 },
  })
  },
}
